export function Trash() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M2 4.4H14M6.8 7.4V10.4M9.2 7.4V10.4M3.2 4.4H12.8L11.852 12.932C11.8195 13.2256 11.6798 13.4969 11.4598 13.694C11.2397 13.8911 10.9546 14 10.6592 14H5.3408C5.04538 14 4.76034 13.8911 4.54025 13.694C4.32016 13.4969 4.1805 13.2256 4.148 12.932L3.2 4.4ZM5.207 2.6882C5.30405 2.48238 5.45762 2.3084 5.6498 2.18655C5.84198 2.06469 6.06485 2 6.2924 2H9.7076C9.93526 1.99988 10.1582 2.06453 10.3505 2.18639C10.5428 2.30824 10.6965 2.48229 10.7936 2.6882L11.6 4.4H4.4L5.207 2.6882V2.6882Z'
        stroke='#FF3E3E'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
